import { ValidatorFn, AbstractControl, ValidationErrors, ControlContainer } from '@angular/forms';
import { CpfValidator } from './cpf-validator';

const tamanhoCNPJSemDV = 12;
const regexCNPJSemDV = /^([A-Z\d]){12}$/;
const regexCNPJ = /^([A-Z\d]){12}(\d){2}$/;
const regexCaracteresMascara = /[./-]/g;
const regexCaracteresNaoPermitidos = /[^A-Z\d./-]/i;
const valorBase = '0'.charCodeAt(0);
const pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const cnpjZerado = '00000000000000';

export const CpfCnpjValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const controlValue = control.value ? control.value.replace(/[\.\-\/]/g, '') : '';

  if (!controlValue) {
    return {};
  }

  if (/[A-Z]/i.test(controlValue)) {
    return CnpjValidator(control);
  }

  if (controlValue.length <= 11) {
    return CpfValidator(control);
  } else {
    return CnpjValidator(control);
  }
};

export const CnpjValidator = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;

  if (value == null || value === '') return null;

  return isValidCNPJ(value) ? null : { invalidCnpj: true };
};

function isValidCNPJ(cnpj: string): boolean {
  if (!regexCaracteresNaoPermitidos.test(cnpj)) {
    const semMascara = removeMascaraCNPJ(cnpj);
    if (regexCNPJ.test(semMascara) && semMascara !== cnpjZerado) {
      const dvInformado = semMascara.substring(tamanhoCNPJSemDV);
      const dvCalculado = calculaDV(semMascara.substring(0, tamanhoCNPJSemDV));
      return dvInformado === dvCalculado;
    }
  }
  return false;
}

function removeMascaraCNPJ(cnpj: string): string {
  return (cnpj ?? '').replace(regexCaracteresMascara, '');
}

function calculaDV(cnpj: string): string {
  if (!regexCaracteresNaoPermitidos.test(cnpj)) {
    const base = removeMascaraCNPJ(cnpj);
    if (regexCNPJSemDV.test(base) && base !== cnpjZerado.substring(0, tamanhoCNPJSemDV)) {
      let somatorioDV1 = 0;
      let somatorioDV2 = 0;
      for (let i = 0; i < tamanhoCNPJSemDV; i++) {
        const asciiDigito = base.charCodeAt(i) - valorBase;
        somatorioDV1 += asciiDigito * pesosDV[i + 1];
        somatorioDV2 += asciiDigito * pesosDV[i];
      }
      const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
      somatorioDV2 += dv1 * pesosDV[tamanhoCNPJSemDV];
      const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);
      return `${dv1}${dv2}`;
    }
  }
  throw new Error('Não é possível calcular o DV pois o CNPJ fornecido é inválido');
}
